// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal .input-field[data-v-1fe589ff]{margin-top:24px}.modal__buttons[data-v-1fe589ff]{display:flex;gap:16px;justify-content:flex-end}.modal__note[data-v-1fe589ff]{color:#707070;font-size:12px;font-weight:400;line-height:150%;margin:8px 0 0}.modal__note a[data-v-1fe589ff]{color:#5ea9ff;-webkit-text-decoration:none;text-decoration:none;transition:color .2s}.modal__note a[data-v-1fe589ff]:hover{color:#aad2ff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
